/**
 * Public Layout Component
 *
 * Custom two-row header layout (no Polaris Frame):
 * - Row 1: Brand bar with logo, search, icons (hides on scroll)
 * - Row 2: Horizontal nav bar (becomes sticky on scroll)
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useScrollHeader } from '../../hooks/useScrollHeader';
import { HeaderBar } from './HeaderBar';
import { NavBar } from './NavBar';
import { MobileMenu } from './MobileMenu';
import { Footer } from './Footer';
import { SearchModal } from '../common/SearchModal';
import { Toast } from '../common/Toast';
import { WhatsAppButton } from '../common/WhatsAppButton';

export function PublicLayout() {
  const { isScrolled, headerRef } = useScrollHeader();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);

  return (
    <div className="app-layout">
      {/* Row 1: Brand Bar — hides on scroll */}
      <HeaderBar
        ref={headerRef}
        isHidden={isScrolled}
        onSearchOpen={() => setSearchModalOpen(true)}
        onMobileMenuOpen={() => setMobileMenuOpen(true)}
      />

      {/* Row 2: Nav Bar — becomes sticky on scroll */}
      <NavBar isSticky={isScrolled} />

      {/* Page Content */}
      <main className="app-content">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />

      {/* Overlays */}
      <MobileMenu
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
      <SearchModal
        open={searchModalOpen}
        onClose={() => setSearchModalOpen(false)}
      />
      <Toast />
      <WhatsAppButton />
    </div>
  );
}
